import { mutualTheme } from './theme'
import { PaletteColor, Palette } from '@material-ui/core/styles/createPalette'

export const extractColorFromPallete = (color: keyof Palette) => {
  return (mutualTheme.palette[color] as PaletteColor).main
}

export const extractPrimaryColorFromPallete = (color: 'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning' | 'default') => {
  if (color === 'default' || color === 'inherit') {
    return color
  }

  return mutualTheme.palette[color].main
}

export const getSidebarWidth = () => {
  return mutualTheme.breakpoints.down('md')
    ? mutualTheme.sidebar.minimizedWidthMdDown
    : mutualTheme.sidebar.minimizedWidthMdUp
}
